<template>
  <Wrapper
    id="platforms-accounts-edit"
    :header="
      $t('_web_profile-edit_preferable-platforms', 'Favourite Platforms')
    "
  >
    <div class="row align-items-center platform-switches-wrapper">
      <PlatformsSwitch
        v-model="accountPlatforms"
        class="col-12 platform-switches"
      />
    </div>
  </Wrapper>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Wrapper from '../../PanelWrapper';
import PlatformsSwitch from '@/components/form/PlatformsSwitch';
export default {
  name: 'AccountEditPlatforms',
  components: {
    PlatformsSwitch,
    Wrapper,
  },
  computed: {
    ...mapGetters(['accountEditData']),
    accountPlatforms: {
      get() {
        return (
          this.accountEditData.__platforms ||
          this.accountEditData.platforms ||
          {}
        );
      },
      set(platforms) {
        if (!this.accountEditData.__prevPlatforms) {
          this.updateEditData({
            __prevPlatforms: this.accountEditData.platforms,
          });
        }
        this.updateEditData({ __platforms: platforms });
      },
    },
  },
  methods: {
    ...mapMutations(['updateEditData']),
  },
};
</script>
<style lang="scss">
@media (max-width: 767px) {
  .platform-switches-wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .platform-switches {
    padding: 0px !important;
  }
}
</style>
